import React, {useEffect, useState} from 'react';
import {FormControl, InputLabel} from "@mui/material";
import Strings from "../../assets/strings";
import {SelectSmart} from "../../components/CustomTextField";
import {getAppUserBancos} from "../../services";
import {IKeyValue} from "../../redux/types/Icommon";

type Props = {
    value?:number | string
    name?:string
    label?:string
    onChange?:(e:React.ChangeEvent<HTMLInputElement>)=>void
    required?:boolean
}




export default function SelectBanco({ value, label="Banco",name="bancoId", onChange, required}:Props) {

    const [bancos, setBancos] = useState<IKeyValue[]>([]);


    useEffect(() => {
        getAppUserBancos({}).then(({data})=>{
            setBancos(data)
        })
    }, [setBancos]);



    //
    // if(!onChange){
    //     let opcion = options.find(o=>o.key === value)
    //     if(opcion) return  <>{opcion.value}</>;
    //     return <>-</>
    // }

    return (

        <FormControl fullWidth required={required}>
            <InputLabel shrink>{label}</InputLabel>
            <SelectSmart
                value={value??""}
                onChange={onChange}
                name={name}
                // loading={paises.status === "loading" }
                opciones={[
                    {key:"",value:Strings.seleccione},
                    ...bancos
                ]}
            />
        </FormControl>

    );
}

